<a *ngIf="!isClickOnRemovingElement" [routerLink]="router"
   [matTooltip]="actTooltip" [matTooltipPosition]="'below'">
  <button
    *ngIf="name && visible"
    class="small-btn"
    mat-button
    color="{{ color }}"
    (click)="press($event)"
    (mouseenter)="defineIsRemovingElement()"
    [disabled]="disabled"
    title="{{ name }}"
  >
    <mat-icon>{{ icon }}</mat-icon>
    <span>{{ name }}</span>
  </button>
</a>

<a *ngIf="isClickOnRemovingElement" [matTooltip]="actTooltip" [matTooltipPosition]="'above'">
  <button
    *ngIf="name && visible"
    class="small-btn"
    mat-button
    color="{{ color }}"
    (click)="press($event)"
    (mouseenter)="defineIsRemovingElement()"
    [disabled]="disabled"
    title="{{ name }}"
  >
    <mat-icon>{{ icon }}</mat-icon>
    <span>{{ name }}</span>
  </button>
</a>

<a *ngIf="!isClickOnRemovingElement" [routerLink]="router" [matTooltip]="actTooltip" [matTooltipPosition]="'above'">
  <button
    *ngIf="!name && visible"
    mat-icon-button
    color="{{ color }}"
    (click)="press($event)"
    (mouseenter)="defineIsRemovingElement()"
    [disabled]="disabled"
    title="{{ name }}"
  >
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</a>

<a *ngIf="isClickOnRemovingElement" [matTooltip]="actTooltip" [matTooltipPosition]="'above'">
  <button
    *ngIf="!name && visible"
    mat-icon-button
    color="{{ color }}"
    (click)="press($event)"
    (mouseenter)="defineIsRemovingElement()"
    [disabled]="disabled"
    title="{{ name }}"
  >
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</a>
